export default {
  auth: '/api/v1/identity/login',
  logout: '/api/v1/identity/logout',
  emailVerification: '/api/v1/identity/verify',
  accountActivation: '/api/v1/identity/activate',
  ownUserInfo: '/api/v1/identity/whoami',
  getOrderDetail: '/api/v1/orders/tracking',
  getOrderByShipment: '/api/v1/orders/tracking/group',
}
